import { Tool } from "../Tool";
import * as React from "react";
import { useDrag } from "react-dnd";
import { DragableTypes } from "../../constants/DragableTypes";
import { BinTypes } from "../../constants/BinTypes";
import { ToolTypes } from "../../constants/ToolTypes";
import { Tooltip } from "@mui/material";
import { useTranslation } from 'react-i18next';


export default function TitleTool() {

    const { t } = useTranslation();

    const artwork = {
        id: ToolTypes.TITLE,
        duration: "5",
        type: BinTypes.TOOL,
        toolType: ToolTypes.TITLE,
        displayName: t("tools.title")
    }
    const [{ opacity }, dragRef] = useDrag(
        () => ({
            type: DragableTypes.ARTWORK,
            item: { artwork },
            collect: (monitor) => ({
                opacity: monitor.isDragging() ? 0.5 : 1,
                width: monitor.isDragging() ? 50 : 100,
                height: monitor.isDragging() ? 50 : 100,
            })
        }),
        []
    )

    return (
        <Tooltip title={ t("tools.title.bin.tooltip") }>
            <Tool
                ref={dragRef}
                variant="outlined"
                square
                style={{ opacity }}
            >
                { t("tools.title.bin.label") }
            </Tool>
        </Tooltip>
    )
}